import { defineMessages } from 'react-intl';

export const electronicProviderNames = defineMessages({
  alavaName: { id: 'gofre.Bai.Names.Alava.name' },
  bizkaiaName: { id: 'gofre.Bai.Names.Bizkaia.name' },
  gipuzkoaName: { id: 'gofre.Bai.Names.Gipuzkoa.name' },
  verifactu: { id: 'gofre.Verifactu.Names.Verifactu.name' },
});
